import React, { useCallback, useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { Routes, Route, useLocation, useNavigate, Navigate, Outlet, } from "react-router-dom"
import Link from './Link'
import { commonActions } from '../actions/commonActions'
import * as commonSelectors from '../components/common/selectors'
import QuartzEditor from '../components/configuration/quartzeditor/QuartzEditor'

const rootLinkUri = '/clientapp/configuration';
const NotFoundRedirect = () => {
    return <Navigate to='/clientapp/not-found' />;
};

const ConfigurationLayout = () => {
    const [hasRight, setHasRight] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const isAuthorizedSelector = useSelector(commonSelectors.isAuthorized);
    const userRights = useSelector(commonSelectors.userRights);

    const location = useLocation();
    const navigateTo = useNavigate();

    const redirectToDefaultPageRoute = useCallback(() => {
        const redirectTo = uri => navigateTo(uri);

        if (hasRight) {
            redirectTo('quartz-editor');
            return;
        }
    }, [hasRight, navigateTo]);

    useEffect(() => {
        const _isAuthorized = isAuthorizedSelector ?? false;
        const _hasRight = userRights?.fullControl ?? false;
        if (_isAuthorized && !_hasRight) {
            commonActions.history.accessForbidden();
        }
        setIsAuthorized(_isAuthorized);
        setHasRight(_hasRight);
        if (_isAuthorized && _hasRight && location.pathname === rootLinkUri) {
            redirectToDefaultPageRoute();
        }
    }, [isAuthorizedSelector, userRights, location.pathname, redirectToDefaultPageRoute]);


    return (
        isAuthorized ?
            <div
                className="d-flex"
                id="wrapper"
            >
                <header>
                    {hasRight &&
                        <div
                            className="bg-dark"
                            id="sidebar-wrapper"
                        >
                            <div className="sidebar-heading">
                                <strong>Configurations</strong>
                            </div>
                            <div className="list-group list-group-flush">
                                {hasRight &&
                                    <Link
                                        to="/clientapp/configuration/quartz-editor"
                                    >
                                        Quartz Editor
                                    </Link>
                                }
                            </div>
                        </div>
                    }
                </header>
                <div id="page-content-wrapper">
                    <Container>
                        <Routes>
                            <Route
                                index
                                element={<Index />}
                            />
                            <Route
                                exact
                                path='quartz-editor'
                                element={<QuartzEditor />}
                            />
                            <Route
                                path='*'
                                element={<NotFoundRedirect />}
                            />
                        </Routes>
                    </Container>
                </div>
            </div>
            : <div />

    )
}

const Index = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default ConfigurationLayout;